<template src="./DetailAnnouncementClosed.html"></template>

<script>
import ChosenUniversity from "../../components/ChosenUniversity/ChosenUniversity";
import announcementService from "../../services/Announcement";
import likeCommentService from "../../services/LikeAndComment";
import { mapGetters } from "vuex";

export default {
  name: "detailAnnouncementClosed",
  components: {
    ChosenUniversity,
  },
  data() {
    return {
      closedAnnouncement: {
        announcement: {
          name: "",
          institution: { name: "" },
          description: "",
          category: { name: "" },
          dateInit: "",
          dateFinish: "",
        },
        averageStars: {},
        groupWinner: {},
      },
      showViewMore: false,
      role: "",
      modalQualification: false,
      rating: {
        qualification: "",
        comment: "",
        institution: "",
      },
      announcementComments: [],
    };
  },
  created() {
    this.role = this.user.role.name;
    this.getSpecificAnnouncement();
  },
  methods: {
    showModalQualification() {
      this.modalQualification = true;
    },
    async commentsRating() {
      try {
        const obj = {
          post: this.closedAnnouncement.announcement.id,
          typePost: "announcement",
          starsNumber: this.rating.qualification,
          comment: this.rating.comment,
        };
        await likeCommentService.commentAndRate(obj);
        this.getSpecificAnnouncement();
        this.modalQualification = false;
        this.$buefy.toast.open({
          duration: 5000,
          message: "Calificación recibida",
          position: "is-bottom",
          type: "is-success",
        });
        this.rating = {};
      } catch (error) {
        console.error("Error grading the course", error);
      }
    },
    async getSpecificAnnouncement() {
      try {
        this.closedAnnouncement =
          await announcementService.getSpecificAnnouncement(
            this.$route.params.id
          );
        const objAnnouncementComments = {
          typePost: "announcement",
          post: this.closedAnnouncement.announcement.id,
        };
        this.announcementComments =
          await likeCommentService.starsAndCommentsByPost(
            objAnnouncementComments
          );
      } catch (e) {
        console.error("error", e);
      }
    },
  },
  computed: {
    roleValidation() {
      return ["Student", "Teacher", "Entrepreneur"].some(
        (a) => a === this.role
      );
    },
    roleValidationTeacherInvestigator() {
      return ["TeacherInvestigator"].some((a) => a === this.role);
    },
    roleValidationAdminAnnouncement() {
      return ["AdministratorCall"].some((a) => a === this.role);
    },
    statusWinner() {
      return (winner) => {
        console.log("recibe", winner);
        switch (winner) {
          case true:
            return winner;
          default:
            null;
            return "En evaluación";
        }
      };
    },
    ...mapGetters({
      user: "getUser",
    }),
  },
};
</script>

<style lang="scss" scoped src="./DetailAnnouncementClosed.scss"></style>